export const getStatus = (formatMessage) => {
  return {
    CREATE: formatMessage({id: "create"}),
    PENDING: formatMessage({id: "allstocktakingissuccessful"}),
    PART_PENDING: formatMessage({id: "partialstocktaking"}),
    FAILED_PENDING: formatMessage({id: "allstocktakingfailed"}),
    PART_COMPLETE: formatMessage({id: "someexecute"}),
    COMPLETE: formatMessage({id: "executed"}),
    FAILED: formatMessage({id: "faileds"})
  };
};
export const getSearchType = (formatMessage) => {
  return {
    ORDER_NO: formatMessage({id: "stocktakingNumber"}),
    MASTER_VARIATION_SKU: "MSKU",
    MASTER_VARIATION_NAME: formatMessage({id: "productName"})
  };
};
export const INVALID_STATUS = ["CREATE", "FAILED_PENDING", "FAILED", "INVALID"];
